"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBbvaByCriteria = void 0;
const calculatePaymentAmount_1 = __importDefault(require("../../shared/useCases/calculatePaymentAmount"));
const bbvaRepository_1 = __importDefault(require("../infraestructure/repositories/bbvaRepository"));
async function findBbvaByCriteria(props) {
    const request = {
        enganche: (0, calculatePaymentAmount_1.default)(props.powerTrain, props.enganchePercentage),
        plazo: props.plazo,
        powerTrainId: props.powerTrain.id,
        seguro: props.seguro,
        year: props.powerTrain.trim.model.year,
    };
    return (0, bbvaRepository_1.default)().findByCriteria(request);
}
exports.findBbvaByCriteria = findBbvaByCriteria;
